
(function () {
  'use strict';

  // Prevent duplicate global event listeners.
  if (window.cartUpsellInitialized) return;
  window.cartUpsellInitialized = true;

  function getTrack(element) {
    return element.closest('.cart-upsell__scroll')
      ?.querySelector('[data-upsell-track]');
  }

  // Keep carousel arrows working after drawer re-renders.
  document.addEventListener('click', function (event) {
    const arrow = event.target.closest(
      '[data-upsell-prev], [data-upsell-next]'
    );

    if (!arrow) return;

    const track = getTrack(arrow);
    if (!track) return;

    const card = track.querySelector('.cart-upsell__product');
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap) || 12;
    const step = card
      ? card.getBoundingClientRect().width + gap
      : track.clientWidth * 0.8;

    const direction = arrow.hasAttribute('data-upsell-prev') ? -1 : 1;

    track.scrollBy({
      left: step * 3 * direction,
      behavior: 'smooth'
    });
  });

  // Allow mouse-wheel scrolling across the horizontal carousel.
  document.addEventListener('wheel', function (event) {
    const track = event.target.closest('[data-upsell-track]');
    if (!track || Math.abs(event.deltaY) < Math.abs(event.deltaX)) return;

    const atStart = track.scrollLeft <= 0;
    const atEnd =
      track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;

    if (
      (event.deltaY < 0 && atStart) ||
      (event.deltaY > 0 && atEnd)
    ) {
      return;
    }

    event.preventDefault();
    track.scrollLeft += event.deltaY;
  }, { passive: false });

  // AJAX add-to-cart using Dawn's native cart drawer rendering.
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-upsell-add]');
    if (!button) return;

    event.preventDefault();

    if (button.disabled || button.classList.contains('is-loading')) return;

    const variantId = button.dataset.variantId;
    const upsell = button.closest('.cart-upsell');
    const addUrl = upsell?.dataset.cartAddUrl;

    if (!variantId || !addUrl) {
      console.error('Cart upsell: Missing variant ID or cart URL.');
      return;
    }

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: 1
          }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(
          data.description || data.message || 'Unable to add product.'
        );
      }

      const drawer = document.querySelector('cart-drawer');

      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      } else {
        // Avoid silently losing a successful add if Dawn's drawer
        // component isn't available.
        window.location.assign('/cart');
      }
    } catch (error) {
      console.error('Cart upsell add-to-cart failed:', error);
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  });

  // Horizontal swipe remains native. Refreshing the page is not required.
})();